import FootballPenaltyShootout from "./FootballPenaltyShootout";
export default FootballPenaltyShootout;
